export enum CustomerQueryKeys {
  customers = "customers",
}
